import React from 'react';

export default function MobileProductConfirmation({
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  disabled = false,
}) {
  return (
    <div className='mp-feedback mp-feedback-error' role='alert'>
      <p>{message}</p>
      <div className='mp-inline-actions'>
        <button type='button' className='btn btn-danger' disabled={disabled} onClick={onConfirm}>
          {confirmLabel}
        </button>
        <button
          type='button'
          className='btn btn-outline-secondary'
          disabled={disabled}
          onClick={onCancel}
        >
          Продовжити редагування
        </button>
      </div>
    </div>
  );
}
